import { render } from "./IncidencesEnrollmentsView.vue?vue&type=template&id=1fd21cb2"
import script from "./IncidencesEnrollmentsView.vue?vue&type=script&lang=js"
export * from "./IncidencesEnrollmentsView.vue?vue&type=script&lang=js"

import "./IncidencesEnrollmentsView.vue?vue&type=style&index=0&id=1fd21cb2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__